export const Preferences = {
  "Modal": {
    "Title": "Preferences",
    "Cancel": "Cancel",
    "Ok": "OK"
  },
  "Content": {
    "Editing": "Editing",
    "AIEnabled":"Enable AI Assistant",
    "FormsTab": "Forms",
    "FullScreen": {
      "Title": "Full Screen",
      "Navigation": "Full Screen Navigation",
      "ShowScrollBar": "Show Scroll Bar",
      "ShowStatusBar": "Show Status Bar",
      "ShowNavigationPanels": "Show Navigation panels",
      "ShowExitButton": "Show Exit Button",
      "showTheWholePage": "One page at a time",
      "MouseClickToScroll": "Left click to go forward one page; right click to go back one page",
      "SecondsInvalid": "The character is not acceptable!",
      "SecondsTooLong": "The character is too long!",
      "LoopScroll": "Loop after last page",
      "AutoFlipPrefix": "Advance Every",
      "AutoFlipSuffix": "seconds",
      "Appearance": "Full Screen Appearance",
      "Background": "Background",
      "fullScreenTransitions": "Full Screen Transitions",
      "ignoreAllTransitions": "Ignore all transitions",
      "defaultTransition": "Default transition",
      "direction": "Direction",
      "navigationControlDirenction": "Navigation control direction",
      "transitions": {
        "noTransition": "No Transition",
        "split": "Split",
        "blinds": "Blinds",
        "box": "Box",
        "wipe": "Wipe",
        "dissolve": "Dissolve",
        "glitter": "Glitter",
        "push": "Push",
        "cover": "Cover",
        "uncover": "Uncover",
        "fade": "Fade",
        "replace": "Replace",
        "fly": "Fly",
        "HI": "Horizontal Inward",
        "HO": "Horizontal Outward",
        "VI": "Vertical Inward",
        "VO": "Vertical Outward",
        "H": "Horizontal",
        "V": "Vertical",
        "I": "Inward",
        "O": "Outward",
        "R": "Right",
        "L": "Left",
        "U": "Up",
        "D": "Down",
        "RU": "Right Up",
        "LU": "Left Up",
        "LD": "Left Down",
        "RD": "Right Down"
      }
    },
    "LayoutGridTab": "Layout Grid",
    "LanguagesTab": "Languages",
    "IdentityTab": "Identity",
    "Document": "Document",
    "DocumentTab": {
      "tabTitle": "Documents",
      "openSettings": {
        "title": "Open Settings",
        "fullScreenAlert": "Alert user when documents request Full Screen",
        "autoUploadToFoxitStorage": "Automatically upload local document to Cloud Documents when the file is opened"
      },
      "viewMode": {
        "title": "PDF/A View Mode",
        "desc": "View document in PDF/A mode",
        "never": "Never",
        "onlyForPDFA": "Only for PDF/A documents"
      },
      "saveSettings": {
        "title": "Save settings",
        "saveFrequency": "Automatically save file every",
        "minutes": "minutes",
        "saveForFastWeb": "Save as optimizes for fast web view"
      },
      "redaction": {
        "title": "Redaction",
        "setredaction": "Adjust filename when saving applied redaction marks",
        "prefix": "Prefix",
        "suffix": "Suffix"
      }
    },
    "MeasureTab": "Measuring",
    "SearchTab": "Search",
    "PageDisplayTab": "Page Display",
    "TrustManagerTab": "Trust Manager",
    "JavaScriptTab": "JavaScript",
    "SecurityTab": "Security",
    "SignatureTab": "Signature",
    "PDFSignTab": "PDF Sign",
    "General": {
      "Title": "General",
      "isAutomatically": "Automatically calculate field values",
      "isRectangle": "Show focus rectangle",
      "ManageButton": "Manage Barcode Parameters",
      "isOverflowIndicator": "Show text field overflow indicator",
      "isHideDocumentMessage": "Always hide document message bar",
      "isHighlight": "Highlight all fields",
      "FieldsHighlight": "Fields highlight",
      "HighlightRequiredFields": "Highlight required fields",
      "isOpenPropertiesAfterCreating": "Open Properties box after creating field",
      "isRunFormRecognition": "Run form recognition when creating PDF in PDF Editor"
    },
    "CommentTab": {
      "title": "Commenting",
      "MakingComments": "Making Comments",
      "TextAsContent": "Copy selected text into Highlight, Squiggly Underline, Underline, and Strikeout comment pop-ups",
      "FloatBar": {
        "Title": "Floating Toolbar",
        "Content": "Pop up floating toolbar after comments created"
      }
    },
    "GeneralTab": {
      "title": "General",
      "basicTools": {
        "title": "Basic Tools",
        "singleKey": "Use single-key accelerators to access tools",
        "fixedResolution": "Use fixed resolution for snapshots",
        "resolution": "Resolution",
        "creatLinkFromUrls": "Create links from URLs",
        "handSelectText": "Make Hand Tool select text",
        "handReadArticles": "Make Hand Tool read articles",
        "handUseMouseZoom": "Make Hand Tool use mouse-wheel zooming"
      }
    },
    "AutoComplete": {
      "Title": "Auto-Complete",
      "AutoCompleteSelect": {
        "off": "Off",
        "basic": "Basic",
        "advanced": "Advanced"
      },
      "RememberNumerical": "Remember numerical data (e.g., telephone number)",
      "EditEntryButton": "Edit Entry List...",
      "TextAreaTxt": "The auto-complete feature is now off. No suggestions will be made while you type in form fields. Choose Basic from the drop-down box to turn the feature on.",
      "TextAreaTxt_basic": "The basic auto-complete feature stores the information you enter into form fields and uses these entries to suggest relevant choices as you type into a field. Once you enter a character into a field, a drop-down box displays a list of only the most probable matches. Double-click or press Down Arrow in an empty field to display an even larger list of possible matches.",
      "TextAreaTxt_advanced": "The advanced auto-complete feature stores the information you enter into form fields and uses these entries to suggest relevant choices as you type into a field. If there are probable matches for a field, tabbing into that field will automatically display a list of them. If there is a very probable match, it will be entered in the field automatically. Pressing Tab while the pointer is over an entry in the list chooses the entry and moves to the next field.",
      "EntryList": {
        "title": "Auto-Complete Entry List",
        "tips": "To clear the entry list,click Remove All.",
        "RemoveAll": "Remove All",
        "Remove": "Remove",
        "close": "Close"
      }
    },
    "Email": {
      "Title": "Email",
      "DefaultSubject": "Default subject",
      "DefaultSubjectRequired": "Please input your subject!",
      "DefaultSubjectInitialvalue": "Data from filename.pdf",
      "DefaultContents": "Default contents",
      "DefaultContentsRequired": "Please input your contents!"
    },
    "LayoutGrid": {
      "Title": "Layout Grid",
      "WidthBetweenLines": "Width between lines",
      "HeightBetweenLines": "Height between lines",
      "inch": "inch",
      "GridOffsestFromLeftEdge": "Grid offset from left edge",
      "GridOffsestFromTopEdge": "Grid offset from top edge",
      "Subdivisions": "Subdivisions",
      "GridLineColcor": "Grid line color"
    },
    "Languages": {
      "Title": "Languages",
      "UseSystem": "Use browser languages",
      "UserCustom": "Choose custom languages"
    },
    "Identity": {
      "Title": "Identity",
      "LoginName": "Login Name:",
      "FirstName": "First Name:",
      "LastName": "Last Name:",
      "SubTitle": "Title:",
      "OrganizationName": "Organization Name:",
      "OrganizationalUnit": "Organizational Unit:",
      "EmailAddress": "Email Address:"
    },
    "Search": {
      "Title": "Search",
      "IgnoreAsia": "Ignore Asia character width",
      "IgnoreDiacritics": "Ignore Diacritics and Accents",
      "AlwaysShowMore": "Always show more options in advanced search",
      "RangeOfWord": "Range of words for Proximity searches:",
      "EmailAddress": "Email Address:"
    },
    "pageDisplay": {
      "layoutAndZoom": {
        "title": "Default Layout and Zoom",
        "navigationTab": {
          "label": "Navigation tab",
          "options": {
            "useInitialView": "Use Initial view",
            "pageOnly": "Page Only",
            "bookmarksPanelAndPage": "Bookmarks Panel and Page",
            "pagesPanelAndPage": "Pages Panel and Page",
            "attachmentsPanelAndPage": "Attachments Panel and Page",
            "layersPanelAndPage": "Layers Panel and Page"
          }
        },
        "defaultPageLayout": {
          "label": "Default Page Layout",
          "options": {
            "autoMatic": "Automatic",
            "singlePage": "Single Page",
            "continuous": "Continuous",
            "facing": "Facing",
            "continuous-Facing": "Continuous-Facing"
          }
        },
        "zoom": {
          "label": "Zoom",
          "options": {
            "autoMatic": "Automatic",
            "actualSize": "Actual Size",
            "fitPage": "Fit Page",
            "fitWidth": "Fit Width",
            "fitVisible": "Fit Visible"
          }
        },
        "customFacing": {
          "label": "Custom Facing",
          "suffix": "Pages"
        },
        "customMargin": {
          "label": "Custom Margin",
          "suffix": "Pixels"
        }
      },
      "rendering": {
        "title": "Rendering",
        "smoothText": {
          "label": "SmoothText",
          "options": {
            "forLaptop_LCDScreens": "For Laptop/LCD Screens",
            "monitor": "Monitor",
            "none": "None"
          }
        },
        "smoothLineArt": "Smooth Line Art",
        "enhanceThinLines": "Enhance thin lines"
      },
      "pageContent": {
        "title": "Page Content",
        "transparencyGrid": "Display transparency grid",
        "logicalPageNum": "Use logical page numbers"
      }
    },
    "measuring": {
      "tabName": "Measuring",
      "unitTitle": "Measurement Units",
      "in": "Inches",
      "cm": "Centimeters",
      "mm": "Millimeters",
      "pt": "Points",
      "pc": "Picas",
      "labelTitle": "Measurement Label",
      "defaultLabel": "Use Default Label",
      "customLabel": "Use Label: ",
      "placeHolder": "click to input custom label.",
      "markupTitle": "Measurement Markup",
      "defaultLeader": "Use Default Leader for Distance Measurement",
      "fromDocument": "Use Scale and Units From Document(When present)"
    },
    "editing": {
      "Editing": {
        "ShowChanged": "Show changed text in",
        "Indent": "Indent Unit",
        "Unit": "Inches"
      },
      "EditingScanned": {
        "Title": "Editing Scanned Document",
        "Alert": "Alert when there's no editable text when using 'Edit Text' tool",
        "Recognize": "Recognize Text",
        "ScannedDocument": "Scanned Document Editing Settings"
      }
    },
    "Security": {
      "Title": "Protected View",
      "Off": "Off",
      "AllFile": "All Files",
      "Tip": "This file originated from a potentially unsafe location, and most features have been disabled to avoid potential security risk.",
      "TipBtn": "Enable All Features"
    },
    "TrustManager": {
      "Ok": "OK",
      "Cancel": "Cancel",
      "Manage": {
        "Title": "Trust Manager",
        "Describe": "Foxit recommends that you check this option for controlling unauthorized actions and data transmissions; including URL connections, launching external files and running JavaScript functions to efficiently avoid attacks from malicious documents.",
        "Enable": "Enable Safe Reading Mode",
        "DisablePart": "Disable Safe Reading Mode for Trusted Documents",
        "AdvanceSetting": {
          "Btn": "Advanced Preferences",
          "Title": "Trusted Documents Setting",
          "Info": "Trusted documents are protected by RMS encryption or a valid digital signature. If you trust the document, please check it.",
          "Rms": "RMS Encryption",
          "Signature": "Digital Signature Verification"
        },
        "Message": {
          "Tip": "This file originated from a potentially unsafe location, and most features have been disabled to avoid potential security risks.",
          "Enable": "Enable All Features"
        }
      },
      "InternetAccess": {
        "Title": "Internet Access from PDF Files outside the web browser",
        "Describe": "Unless explicitly permitted, PDF files cannot send information to the Internet.",
        "Setting": {
          "Btn": "Change Settings",
          "Title": "Manage Sites",
          "Info": "PDF files may connect to web sites to share or get information.",
          "Type": {
            "Custom": "Custom setting",
            "Allow": "Allow PDF files to access all web sites",
            "Block": "Block PDF files' access to all web sites"
          },
          "Specify": {
            "Title": "Specify Web Sites to Allow or Block",
            "SubTitle": "Host name (www.example.com):",
            "Allow": "Allow",
            "Block": "Block"
          },
          "Site": {
            "Title": "Web Sites",
            "Delete": "Delete",
            "Name": "Sites Name",
            "Access": "Access Right",
            "Tip": "Default behavior for web sites that are not in the above list:",
            "Always": "Always ask",
            "Allow": "Allow access",
            "Block": "Block access"
          }
        },
        "Message": {
          "Title": "Security Warning",
          "TipTop": "The document is trying to connect to",
          "TipBottom": "If you trust the site, choose Allow. If you don't trust the site, choose Block.",
          "Remember": "Remember this action for this site for all PDF documents.",
          "Allow": "Allow",
          "Block": "Block",
          "Cancel": "Cancel",
          "ExistUrlInfo": "The host name already exists and cannot be added."
        }
      }
    },
    "JavaScript": {
      "Title": "JavaScript",
      "Subtitle": "JavaScript Console",
      "EnableActions": "Enable JavaScript Actions",
      "ExternalFile": "Use External JavaScript Editor",
      "ButtonInfo": "Browser"
    },
    "Signature": {
      "Title": "Signing&Verifications",
      "content": "Control how and when signatures are verified",
      "button": "Change Settings",
      "Dialog": {
        "Title": "Signature Verification Preferences",
        "openVerifyLabel": "Verify signatures when the document is opened",
        "untrustedSignaturesVerifyLabel": "When document has valid but untrusted signatures, prompt to review and trust signers",
        "beforeSetTitle": "Verification Behavior",
        "certificateRevocation": "Require certificate revocation checking to succeed whenever possible during signature verification",
        "expiredTimestamps": "Use expired timestamps",
        "ignoreDocInfo": "Ignore document validation information",
        "verificationTime": "Verification Time",
        "usingTimeType": "Verify Signature Using:",
        "createdTime": "Time at which the signature was created",
        "secureTime": "Secure time (timestamp) embedded in the signature",
        "currentTime": "Current time"
      },
      "signAfter":"Sign the document immediately after the signature is placed."
    },
    "PDFSign": {
      "inkSignTitle": "Ink Sign",
      "inkSignContent": "Flatten the document when applying all signatures",
      "inkSignTip": "This will make all signatures, text objects and other annotations embedded into the documents.",
      "foxitESignTitle": "Foxit eSign",
      "foxitESignContent": "Disable Foxit eSign service"
    }
  }
}